import type { Sale } from '../../lib/api.js';

/// Um produto da venda que sai do estoque na hora: a apresentação vendida e quantas.
export interface SaleStockNeed {
  referenceId: string;
  label: string;
  quantity: number;
}

/// O serviço avulso vendido para marcar depois: a venda já tem o pagamento, e a Agenda é dona do
/// horário (ADR 0046, decisão 4). Venda nascida do atendimento não aparece aqui: já tem o seu.
export function hasServicesToSchedule(sale: Sale): boolean {
  return (
    sale.status === 'CONFIRMED' &&
    !sale.appointmentId &&
    sale.items.some((item) => item.kind === 'SERVICE' && item.fulfillment === 'IMMEDIATE')
  );
}

/// Recusas que se corrigem no bloco da saída do estoque, e não no fim do formulário.
export function isStockRefusal(code: string | undefined): boolean {
  return Boolean(code?.startsWith('INVENTORY_') || code === 'SALES_STOCK_LOCATION_REQUIRED');
}
